import { Stack, Typography } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { FunnelImage } from 'core/flow/entities';
import { WingImageStyled, WingImageReversedStyled, ContentStyled } from './styled';

type SocialReviewProps = {
  content: {
    image: FunnelImage;
    topText: string;
    bottomText: string;
  };
};

export const SocialReview = ({ content }: SocialReviewProps) => {
  const { image, topText, bottomText } = content;

  return (
    <Stack direction="row" alignItems="center" justifyContent="center">
      <WingImageStyled src={image.src} alt={image.alt} width={30} height={50} />
      <ContentStyled>
        <Typography
          align="center"
          variant="text-body-sm"
          dangerouslySetInnerHTML={prepareHtml(topText)}
        />
        <Typography
          align="center"
          variant="text-body-sm"
          dangerouslySetInnerHTML={prepareHtml(bottomText)}
        />
      </ContentStyled>
      <WingImageReversedStyled src={image.src} alt={image.alt} width={30} height={50} />
    </Stack>
  );
};
